<div class="foldable-content" #wrapper>
    <div class="foldable-content__content" style="width: 100%;">
      <ul class="foldable-content__list" #content>
        <li class="foldable-content__item" *ngFor="let item of renderedItems" [hidden]="!item.rendered" [ngClass]="getRenderingClass(item)" [ngStyle]="getRenderingStyling(item)">
          <img default="/assets/img/default-product-icon.svg" [src]="getImageSource(item)" *ngIf="hasImage(item)" [ngClass]="getImageRenderingClass(item)" [ngStyle]="getImageRenderingStyling(item)" [title]="getImageRenderingTitle(item)" />
          <span>{{ getRendering(item) }}</span>
        </li>
      </ul>
      <ng-template #tipContent><p *ngFor="let hiddenItem of hiddenItems" style="margin: 0;">{{ hasImage(hiddenItem) ? getImageRenderingTitle(hiddenItem) : getRendering(hiddenItem) }}</p></ng-template>
      <p class="foldable-content__more" [hidden]="hiddenItems.length === 0" #counter
        data-toggle="popover" data-html="true" [attr.data-content]="getTooltipText" data-container="body"
        data-placement="left" data-trigger="hover">
        <span>+{{ hiddenItems.length }}</span>
      </p>
    </div>
</div>
